<ng-container [formGroup]="form">
  <div class="flex gap-1">
    <app-form-control [withBottomMargin]="false">
      <p-select
        [fluid]="true"
        [formControl]="form.controls.prefix"
        [options]="valueOrDefault(prefixesSelectItems$ | async, [])" />
    </app-form-control>

    @let mask = numberMask();

    <div class="flex-1">
      <app-form-control [withBottomMargin]="false">
        @if (isNil(mask)) {
          <input
            [fluid]="true"
            [formControl]="form.controls.number"
            appPrimengInputText
            pInputText
            placeholder="999-999-999"
            type="tel" />
        } @else {
          <p-inputmask
            [fluid]="true"
            [formControl]="form.controls.number"
            [mask]="mask"
            [placeholder]="mask"
            type="tel" />
        }
      </app-form-control>
    </div>
  </div>
</ng-container>
